import React, { ReactNode } from 'react'
import Icon from '../icon'

export const EmptyState: React.FC<{ text?: ReactNode; image?: string }> = ({
  text = `There's nothing to see here`,
  image,
}) => {
  return (
    <div
      className="
          flex flex-col gap-4
          items-center justify-center
          w-full my-10 py-10
          text-sec-black
        "
    >
      {image ? (
        <img
          src={image}
          alt="404"
          className="aspect-square w-full max-w-[225px] block object-cover"
        />
      ) : (
        <div>
          <Icon id="empty-file" width={84} height={101} />
        </div>
      )}

      <p className="text-center text-lg font-medium font-recoleta text-black">
        {text}
      </p>
    </div>
  )
}
